class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;
    this.getSectionsToRender().forEach((section) => {
      document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });

    // Also update footer cart icon
    this.updateFooterCartIcon(parsedState);
    
    if (typeof publish !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
      publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-notification', cartData: parsedState });
    }
    if (this.header) this.header.reveal();
    this.open();
  }

  updateFooterCartIcon(parsedState) {
    const footerCartIcon = document.querySelector('#cart-icon-bubble2');
    const drawerCartIcon = document.querySelector('#cart-icon-bubble3');
    
    if ((!footerCartIcon && !drawerCartIcon) || !parsedState.sections || !parsedState.sections['cart-icon-bubble']) return;

    try {
      // Use the same method as header cart icon to extract content
      const cartIconContent = this.getSectionInnerHTML(
        parsedState.sections['cart-icon-bubble'],
        '.shopify-section'
      );
      
      // Update footer cart icon
      if (footerCartIcon) {
        footerCartIcon.innerHTML = cartIconContent;
      }
      
      // Update header drawer cart icon
      if (drawerCartIcon) {
        drawerCartIcon.innerHTML = cartIconContent;
      }
      
      // Re-attach event listeners after update
      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer) {
        if (typeof cartDrawer.setHeaderCartIconAccessibilityFooter === 'function') {
          cartDrawer.setHeaderCartIconAccessibilityFooter();
        }
        if (typeof cartDrawer.setHeaderDrawerCartIconAccessibility === 'function') {
          cartDrawer.setHeaderDrawerCartIconAccessibility();
        }
      }
    } catch (e) {
      console.error('Error updating cart icons:', e);
    }
  }

  // updateFooterCartIcon(parsedState) {
  //   const footerCartIcon = document.querySelector('#cart-icon-bubble2');
  //   if (!footerCartIcon || !parsedState.sections || !parsedState.sections['cart-icon-bubble']) return;

  //   try {
  //     // Use the same method as header cart icon to extract content
  //     const cartIconContent = this.getSectionInnerHTML(
  //       parsedState.sections['cart-icon-bubble'],
  //       '.shopify-section'
  //     );
  //     footerCartIcon.innerHTML = cartIconContent;
  //     // Re-attach event listeners after update
  //     const cartDrawer = document.querySelector('cart-drawer');
  //     if (cartDrawer && typeof cartDrawer.setHeaderCartIconAccessibilityFooter === 'function') {
  //       cartDrawer.setHeaderCartIconAccessibilityFooter();
  //     }
  //   } catch (e) {
  //     console.error('Error updating footer cart icon:', e);
  //   }
  // }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
